import * as React from 'react';
import { createPortal } from 'react-dom';

import {
  CheckIcon,
  EmailIcon,
  LinkIcon,
  MessengerIcon,
  ReactFCC,
  WhatsappIcon,
} from '@notino/react-styleguide';

import { useShadefinderAppId } from '../../queries/useShadefinderAppId';

import {
  SocialButton,
  SocialButtonsWrapper,
  WrapperArrowUp,
  WrapperArrowDown,
} from './styled';

interface SharePopupProps {
  direction: 'up' | 'down';
  innerRef: React.RefObject<HTMLDivElement>;

  left: number;
  top: number;
}

const SharePopup: ReactFCC<SharePopupProps> = ({
  direction,
  innerRef,
  top,
  left,
}) => {
  const shareUrl = window.location.href;
  const encodedShareUrl = encodeURIComponent(shareUrl);
  const facebookAppId = useShadefinderAppId();
  const [isCopied, setIsCopied] = React.useState(false);

  return createPortal(
    <SocialButtonsWrapper
      direction={direction}
      ref={innerRef}
      top={top}
      left={left}
    >
      {direction === 'down' && <WrapperArrowUp />}

      <SocialButton href={`mailto:?body=${encodedShareUrl}`}>
        <EmailIcon color="icon.primary" width="20px" height="20px" />
      </SocialButton>
      <SocialButton
        href={`https://wa.me/?text=${encodedShareUrl}`}
        target="_blank"
      >
        <WhatsappIcon width="20px" height="20px" />
      </SocialButton>
      <SocialButton
        href={`http://www.facebook.com/dialog/send?app_id=${facebookAppId}&link=${encodedShareUrl}&redirect_uri=${encodedShareUrl}`}
        target="_blank"
      >
        <MessengerIcon width="20px" height="20px" />
      </SocialButton>
      <SocialButton
        onClick={async () => {
          await navigator.clipboard.writeText(`${shareUrl}`);
          setIsCopied(true);
          setTimeout(() => setIsCopied(false), 2000);
        }}
      >
        {isCopied ? (
          <CheckIcon color="icon.positive" width="20px" height="20px" />
        ) : (
          <LinkIcon color="icon.primary" width="20px" height="20px" />
        )}
      </SocialButton>

      {direction === 'up' && <WrapperArrowDown />}
    </SocialButtonsWrapper>,
    document.getElementById('multistep-modal-popups')
  );
};

export default SharePopup;
